import React, { useState } from 'react';

import cs from 'classnames';

import Icon from 'components/shared/Icon/Icon';

import AssetsSidebarList from './AssetsSidebarList';

const AssetsSidebar = () => {
  const [expanded, setExpanded] = useState(true);
  const handleExpanded = () => setExpanded(!expanded);

  return (
    <div
      className={cs(
        'z-10 h-auto w-6 rounded-br-lg rounded-tr-lg bg-white !py-4 px-1 shadow-md duration-200 ease-out',
        expanded && 'w-[230px] min-w-[230px] !px-3'
      )}
      data-dd-privacy="allow">
      <div className="sticky top-0">
        <Icon
          icon={expanded ? 'chevron-left-filled' : 'chevron-right-filled'}
          className="flex cursor-pointer justify-end !pb-1"
          onClick={handleExpanded}
        />
        <AssetsSidebarList expanded={expanded} />
      </div>
    </div>
  );
};

export default AssetsSidebar;
